export default "__VITE_ASSET__BIDZzD_m__"